export default {
    'create-custom-statement': 'إنشاء كشف مُخصص',
    'edit-custom-statement': 'تعديل كشف مُخصص',
    'custom-statement-name': 'اسم الكشف المُخصص',
    'accounts': 'الحسابات',
    save: 'حفظ',
    cancel: 'إلغاء',
    'delete-the-custom-statement': 'حذف الكشف المُخصص',
    'are-you-sure-you-want-to-delete-the-custom-statement': 'هل أنت متأكد من حذف الكشف المُخصص؟',

    headers: {
        'custom-statement-name': 'اسم الكشف المُخصص',
        'used-accounts': 'الحسابات التي تنتمي له',
        'actions': 'الأحداث',
    }
}